import { Component, inject } from '@angular/core';
import { PwaService } from './pwa.service';

@Component({
  selector: 'app-pwa-controls',
  standalone: true,
  template: `
    @if (pwa.connectionLost()) {
      <section class="connection" role="alertdialog" aria-modal="true" aria-labelledby="connection-title" aria-describedby="connection-description">
        <div class="card">
          <h2 id="connection-title">No podemos actualizar los datos</h2>
          <p id="connection-description">Se ha perdido la conexión con League of Managers. Los datos anteriores no se muestran como actuales y no se pueden realizar operaciones.</p>
          <p>Tus cambios en esta pantalla se conservan mientras no recargues. Si una operación estaba en curso, comprueba su resultado al volver antes de repetirla.</p>
          <button type="button" (click)="pwa.reload()" [disabled]="!pwa.online()">Volver a conectar y recargar</button>
          @if (!pwa.online()) { <p role="status">Esperando conexión…</p> }
        </div>
      </section>
    } @else if (pwa.enabled) {
      <aside class="controls" aria-label="League of Managers">
        @if ((pwa.updateReady() && !pwa.updateDismissed()) || pwa.recoveryRequired()) {
          <div class="card" role="status">
            <p>{{ pwa.recoveryRequired() ? 'Es necesario recargar League of Managers.' : 'Hay una nueva versión de League of Managers disponible.' }}</p>
            <button type="button" (click)="pwa.reload()" [disabled]="!pwa.online()">Recargar</button>
            @if (!pwa.recoveryRequired()) { <button type="button" class="secondary" (click)="pwa.updateDismissed.set(true)">Más tarde</button> }
          </div>
        }
        @if (pwa.error()) {
          <div class="card" role="status">
            <p>{{ pwa.error() }}</p>
            <button type="button" class="secondary" (click)="pwa.checkForUpdate(true)">Comprobar de nuevo</button>
            <button type="button" class="secondary" (click)="pwa.error.set('')">Cerrar</button>
          </div>
        }
        @if (pwa.canInstall()) {
          <div class="card install">
            <button type="button" (click)="pwa.install()" [disabled]="pwa.installing()" [attr.aria-expanded]="pwa.ios ? pwa.iosHelp() : null">Instalar League of Managers</button>
            <button type="button" class="secondary" aria-label="Ocultar opción de instalación" (click)="pwa.installDismissed.set(true)">Cerrar</button>
            @if (pwa.iosHelp()) {
              <p>En Safari, abre Compartir y selecciona «Añadir a pantalla de inicio». Si aparece, activa «Abrir como app». Después pulsa «Añadir».</p>
            }
          </div>
        }
      </aside>
    }
  `,
  styles: `
    .controls { position: fixed; right: 1rem; bottom: calc(5.5rem + env(safe-area-inset-bottom)); z-index: 60; max-width: min(24rem, calc(100vw - 2rem)); display: grid; gap: .5rem; }
    .card { background: var(--fm-bg-surface, #fff); color: var(--fm-text-primary, #0f172a); padding: 1rem; border: 1px solid var(--fm-border-subtle, #e2e8f0); border-radius: 1rem; box-shadow: 0 4px 16px #0002; font-size: .875rem; }
    p { margin: 0 0 .75rem; line-height: 1.5; }
    h2 { font-size: 1.25rem; font-weight: 700; margin: 0 0 1rem; }
    button { border-radius: .5rem; padding: .5rem .75rem; background: #047857; color: white; font-weight: 600; cursor: pointer; }
    button:focus-visible { outline: 3px solid #059669; outline-offset: 3px; }
    button:disabled { opacity: .5; cursor: default; }
    .secondary { background: transparent; color: inherit; margin-left: .5rem; text-decoration: underline; }
    .install p { margin-top: .75rem; }
    .connection { position: fixed; inset: 0; z-index: 1000; background: var(--fm-bg-base, #f8fafc); display: grid; place-items: center; padding: 1.5rem; overflow: auto; }
    .connection .card { max-width: 32rem; }
  `,
})
export class PwaControlsComponent {
  readonly pwa = inject(PwaService);
}
